import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://api.mschat.msdiscoveries.com';
axios.defaults.baseURL = API;

const AuthContext = createContext(null);

// Decode JWT token to get role — no library needed, just base64 decode
function getRoleFromToken(token) {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded.role || null;
  } catch(e) {
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mschat_token');
    const savedUser = localStorage.getItem('mschat_user');

    if (token && savedUser) {
      // Always get role from JWT token — never trust localStorage role
      const tokenRole = getRoleFromToken(token);
      if (tokenRole) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        setUser(JSON.parse(savedUser));
        setRole(tokenRole);
        // Fix localStorage role if it was wrong
        localStorage.setItem('mschat_role', tokenRole);
      } else {
        // Token invalid — clear everything
        localStorage.removeItem('mschat_token');
        localStorage.removeItem('mschat_user');
        localStorage.removeItem('mschat_role');
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, userRole, token) => {
    // Double check role from token
    const tokenRole = getRoleFromToken(token) || userRole;
    localStorage.setItem('mschat_token', token);
    localStorage.setItem('mschat_user', JSON.stringify(userData));
    localStorage.setItem('mschat_role', tokenRole);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
    setRole(tokenRole);
  };

  const logout = () => {
    localStorage.removeItem('mschat_token');
    localStorage.removeItem('mschat_user');
    localStorage.removeItem('mschat_role');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ user, role, loading, login, logout, API }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);